import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg"
import { toast } from "react-toastify";



export default function Header() {
  const [shareLinkCopied, setShareLinkCopied] = React.useState(false);
  useEffect(() => {
    if (window.loadDynamicFonts) {
      window.loadDynamicFonts();
    }
  });
  useEffect(() => {
    if (shareLinkCopied) {
      toast.success("Link Copied to Clipboard!");
    }
  });
  return (
    <>
    <header className="flex  items-center justify-center  w-full h-full">
      <nav className="flex items-center justify-center  w-full h-full">
        <div className="flex items-center justify-center w-full h-full">
          <div className="flex items-center justify-between mx-4 w-full h-full">
          <Link to="/">  <div className="flex items-center justify-center p-2 sm:ml-4">
              <img src={logo} alt="brahmastra logo" className="w-24 h-24" />
            </div></Link>
            <div className="flex flex-row gap-2 items-center justify-center p-2 sm:mr-4">
              <div className="flex items-center justify-center p-2 flex-row gap-6" onClick={() => {
            navigator.clipboard.writeText("https://cdn.jsdelivr.net/gh/YAKSHIT-22/Brahmastra@main/main/main.js");
            setShareLinkCopied(true);
            setTimeout(() => {
              setShareLinkCopied(false);
            }, 2000);
          }}>
                <svg width="34" height="34" xmlns="http://www.w3.org/2000/svg">
                  <style>
                    {`.st1{fill:#bd483b}.st3{fill:#fec82f}.st4{fill:#df9c26}`}
                  </style>
                  
                  <path
                    className="st1"
                    d="M15.386.338L12.28 11.376v11.143l3.106 11.143 3.194-11.143V11.376L15.386.338z"
                  />
                  <path
                    fill="#e64e3d"
                    d="M15.386.338L0 5.88l2.186 20.492 13.2 7.29"
                  />
                  <path
                    className="st1"
                    d="M15.386 33.662l13.268-7.365 2.483-20.49L15.386.338"
                  />
                  <path
                    className="st3"
                    d="M12.594 25.088a9.358 9.358 0 01-3.94-2.431l-.003-.002a9.342 9.342 0 01-2.238-3.814c.251.233.518.447.796.647.003.008.008.016.011.027-.003-.012-.008-.02-.011-.027a8.622 8.622 0 001.696.923c.177.07.36.135.542.195.011.006.024.006.035.01.032.012.065.023.097.033a1.702 1.702 0 001.39 1.504c.287 1.157.833 2.146 1.625 2.935zm.58-13.294c0 .324.088.627.243.883-1.25 1.753-2.108 3.656-2.479 5.539-.041.209-.077.416-.105.619-.429.113-.79.393-1.016.762a.071.071 0 01-.035-.01c-.023-.006-.04-.014-.061-.021a7.157 7.157 0 01-2.796-1.715 6.814 6.814 0 01-.311-.332l-.041-.049-.115-.137-.047-.059c-.014-.018-.024-.031-.037-.045-.005-.01-.013-.016-.017-.023-.02-.022-.037-.047-.053-.068-.008-.012-.017-.022-.023-.029l-.004-.008c-.013-.014-.024-.033-.037-.049a3.928 3.928 0 01-.157-.225c-.009-.012-.019-.024-.025-.039a.146.146 0 01-.02-.027 9.338 9.338 0 012.227-6.703 9.361 9.361 0 014.299-2.847c.026.182.059.367.095.553.192.967.513 1.942.949 2.898-.271.3-.434.698-.434 1.132zm-.998 8.685a.89.89 0 01-.308.68.899.899 0 01-1.068.09.91.91 0 01-.342-.375.901.901 0 01-.089-.395.896.896 0 01.377-.732.898.898 0 011.285.245.86.86 0 01.145.487zm3.601-8.685a.902.902 0 01-.902.905c-.044 0-.087-.002-.128-.006-.008-.004-.016-.004-.025-.006a.902.902 0 01.153-1.794h.038a.907.907 0 01.864.901z"
                  />
                  <path
                    className="st4"
                    d="M24.752 16.143c0 .907-.129 1.782-.368 2.61a12.751 12.751 0 01-2.4-.914 1.694 1.694 0 00-.092-.975 14.936 14.936 0 002.499-3.306c.234.821.361 1.69.361 2.585zm-.871-3.947a11.29 11.29 0 01-.201.416 13.81 13.81 0 01-2.487 3.434 1.703 1.703 0 00-1.883.084 16.75 16.75 0 01-1.49-1.327 16.677 16.677 0 01-1.647-1.909 1.695 1.695 0 00.168-1.964 15.981 15.981 0 013.917-2.788 9.414 9.414 0 013.623 4.054zm-2.664 5.307a.902.902 0 01-1.804.081c.011-.01.021-.016.028-.022-.01-.008-.021-.014-.03-.023l-.001-.037a.907.907 0 011.165-.864.909.909 0 01.642.865zm.235 1.264a1.7 1.7 0 01-2.088.151c-.039.025-.078.051-.115.072a13.708 13.708 0 01-3.864 1.698v4.824a9.373 9.373 0 008.64-5.744 14.047 14.047 0 01-2.573-1.001z"
                  />
                  <path
                    className="st3"
                    d="M15.386 20.688a11.71 11.71 0 01-2.385.367l-.128.008c-.151.41-.454.744-.839.94.245.909.688 1.698 1.319 2.327.524.524 1.162.92 1.891 1.18l.142.002v-4.824z"
                  />
                  <path
                    className="st4"
                    d="M18.612 17.503c0-.172.026-.34.074-.498a17.925 17.925 0 01-3.3-3.376v5.946a12.866 12.866 0 003.321-1.511 1.698 1.698 0 01-.095-.561z"
                  />
                  <path
                    className="st3"
                    d="M15.386 13.629c-.045-.059-.091-.113-.132-.174a1.716 1.716 0 01-1.015-.08c-1.134 1.606-1.912 3.341-2.25 5.049-.032.162-.059.32-.083.475.477.195.848.596.996 1.092.016-.004.029-.004.046-.004.809-.039 1.627-.18 2.438-.412v-5.946z"
                  />
                  <path
                    className="st4"
                    d="M15.386 6.778v3.394c.048.016.098.033.145.055a17.238 17.238 0 013.573-2.681 9.3 9.3 0 00-3.718-.768z"
                  />
                  <path
                    className="st3"
                    d="M15.386 6.778c-.608 0-1.201.055-1.773.168.025.197.06.404.101.606.168.86.449 1.725.829 2.575a1.694 1.694 0 01.843.045V6.778z"
                  />
                </svg>
              </div>
          <a href="https://github.com/YAKSHIT-22/Brahmastra" target="_blank" rel="noopener noreferrer"><div className="flex items-center justify-center p-2">
                <svg
                  viewBox="0 0 16 16"
                  className="w-[30px] h-[30px]"
                  fill="white"
                  aria-hidden="true"
                >
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
                </svg>
              </div></a>
            </div>
          </div>
        </div>
      </nav>
     
    </header>
    </>
  );
}
